import { IWantToSell } from '@components/IWantToSell/IWantToSell';

export const IWantToSellPage = () => {
  return <IWantToSell />;
};
